import { QueryClient } from '@tanstack/react-query';

import { ApiError } from '../api/rpc';

const clientError = (error: unknown): boolean =>
  (error instanceof ApiError && error.status < 500) ||
  (error instanceof Error && /API call failed: 4\d\d/.test(error.message));

// Explicit invalidation only; a 4xx is a missing object — never retry into it.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      gcTime: 30 * 60_000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: (failureCount, error) => !clientError(error) && failureCount < 1,
    },
  },
});
